import { observer } from "mobx-react";
import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Tracking, } from "restaumatic-client";
import Alert from "../../components/Alert";
import MenuGroupSectionItem from "./MenuGroupSectionItem";
function AIWaiterResult(props) {
    const { aiWaiter, openProductCreator } = props;
    const { state } = aiWaiter;
    switch (state.type) {
        case "NotRequested":
            return (h(Fragment, null,
                h(CautionNote, null),
                h(HintAlert, null)));
        case "Loading":
            return (h(Fragment, null,
                h(CautionNote, null),
                h(ResultSkeleton, null)));
        case "Error":
            return (h(Fragment, null,
                h(CautionNote, null),
                h(Alert, { type: "danger", message: state.error })));
        case "Success":
            return (h(Fragment, null,
                h(CautionNote, null),
                h(Success, { message: state.message, items: state.items, openProductCreator: openProductCreator })));
    }
}
function HintAlert() {
    return (h(Alert, { type: "info", message: h(Fragment, null,
            h("b", null, "Przyk\u0142ady"),
            h("ul", null,
                h("li", null, "Co\u015B s\u0142odkiego na deser"),
                h("li", null, "Skompletuj mi dwudaniowy obiad"),
                h("li", null, "Sam nie wiem, co\u015B polecasz?"))) }));
}
function CautionNote() {
    return (h("p", { class: "text-muted u-font-size-small" },
        "Funkcja korzysta z technologii sztucznej inteligencji. Zadaj\u0105c pytanie, akceptujesz",
        " ",
        h("a", { href: "/privacy-policy" }, "polityk\u0119 prywatno\u015Bci.")));
}
function ResultSkeleton() {
    return (h("div", { role: "status", "aria-label": "Trwa szukanie produkt\u00F3w pasuj\u0105cych do Twojego zapytania" },
        h("div", { class: "m-skeleton u-my4" },
            h("div", { style: "width:56px; height:56px; margin-inline: 1rem; border-radius: 4px;", class: "m-skeleton__item" }),
            h("div", { style: "gap:0.5rem;", class: "d-flex flex-column u-flex-grow" },
                h("div", { style: "width:30%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:60%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }))),
        h("hr", { class: "m-hr" }),
        h("div", { class: "m-skeleton u-my4" },
            h("div", { style: "width:56px; height:56px; margin-inline: 1rem; border-radius: 4px;", class: "m-skeleton__item" }),
            h("div", { style: "gap:0.5rem;", class: "d-flex flex-column u-flex-grow" },
                h("div", { style: "width:30%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:60%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }))),
        h("hr", { class: "m-hr" }),
        h("div", { class: "m-skeleton u-my4" },
            h("div", { style: "width:56px; height:56px; margin-inline: 1rem; border-radius: 4px;", class: "m-skeleton__item" }),
            h("div", { style: "gap:0.5rem;", class: "d-flex flex-column u-flex-grow" },
                h("div", { style: "width:30%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:60%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }))),
        h("hr", { class: "m-hr" }),
        h("div", { class: "m-skeleton u-my4" },
            h("div", { style: "width:56px; height:56px; margin-inline: 1rem; border-radius: 4px;", class: "m-skeleton__item" }),
            h("div", { style: "gap:0.5rem;", class: "d-flex flex-column u-flex-grow" },
                h("div", { style: "width:30%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:100%; height:16px; border-radius: 4px;", class: "m-skeleton__item" }),
                h("div", { style: "width:60%; height:16px; border-radius: 4px;", class: "m-skeleton__item" })))));
}
function FeedbackSurvey() {
    const [isFilled, setIsFilled] = useState(false);
    const [showThanks, setShowThanks] = useState(false);
    useEffect(() => {
        if (isFilled) {
            setTimeout(() => setShowThanks(true), 1000);
        }
    }, [isFilled]);
    return (h("article", { class: "m-ai-search__survey" }, showThanks ? (h("div", { class: "m-ai-search__survey-thx" }, "Dzi\u0119kujemy za opini\u0119!")) : (h(Fragment, null,
        h("span", { class: "u-mr2" }, "Czy jeste\u015B zadowolony z wyniku?"),
        h("div", { class: "d-flex" },
            h("button", { type: "button", class: "m-ai-search__survey-btn u-btn-unstyled", onClick: () => {
                    setIsFilled(true);
                    Tracking.trackEvent({ tag: "AiWaiterFeedbackHelpful" });
                }, "aria-label": "Jestem zadowolony" },
                h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24", viewBox: "0 0 24 24", width: "24", "aria-hidden": "true" },
                    h("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
                    h("circle", { cx: "15.5", cy: "9.5", r: "1.5" }),
                    h("circle", { cx: "8.5", cy: "9.5", r: "1.5" }),
                    h("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-2.5c2.33 0 4.32-1.45 5.12-3.5h-1.67c-.69 1.19-1.97 2-3.45 2s-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5z" }))),
            h("button", { type: "button", class: "m-ai-search__survey-btn u-btn-unstyled", onClick: () => {
                    setIsFilled(true);
                    Tracking.trackEvent({ tag: "AiWaiterFeedbackNotHelpful" });
                }, "aria-label": "Nie jestem zadowolony" },
                h("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24", viewBox: "0 0 24 24", width: "24", "aria-hidden": "true" },
                    h("path", { d: "M0 0h24v24H0V0z", fill: "none" }),
                    h("circle", { cx: "15.5", cy: "9.5", r: "1.5" }),
                    h("circle", { cx: "8.5", cy: "9.5", r: "1.5" }),
                    h("path", { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z" }))))))));
}
const Success = observer((props) => {
    const { message, items, openProductCreator } = props;
    const handleOpenProductCreator = (productInstanceCreator, content) => {
        openProductCreator(productInstanceCreator);
        Tracking.trackEvent({
            tag: "AiWaiterOpenProductCreator",
            contents: {
                productTypeId: productInstanceCreator.productTypeIds.toString(),
                name: content.name,
                hasPhoto: content.photoUrn !== null && content.photoUrn !== "",
            },
        });
    };
    return (h(Fragment, null,
        h("p", null, message),
        h("div", { class: "m-list m-list--list" },
            h("ul", { class: "m-list__list" }, items.map((item) => (h(MenuGroupSectionItem, { key: item.sectionItem.id, openProductCreator: (productInstanceCreator) => handleOpenProductCreator(productInstanceCreator, item.sectionItem.content), menuSectionId: item.sectionId, menuSectionItem: item.sectionItem, menuSectionItemId: item.sectionItem.id }))))),
        h(FeedbackSurvey, null)));
});
export default observer(AIWaiterResult);
